import { Capacitor, CapacitorCookies } from '@capacitor/core';

// Android's WebView writes cookies to disk only every ~30 s, so an app restart right after
// login brought back the old guest session. Deleting a dummy cookie forces a native flush.
export async function persistNativeCookies() {
    if (Capacitor.getPlatform() !== 'android') return;
    try {
        await CapacitorCookies.deleteCookie({ url: window.location.origin, key: 'wl_cookie_flush' });
    } catch {
        // Best effort: the cookie still lands on disk within ~30 s.
    }
}
